import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const NAV_LINKS = [
  { href: '#projects', label: 'Projects' },
  { href: '/about', label: 'About' },
  { href: '/discover', label: 'Discover' },
  { href: '#contact', label: 'Contact' },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (!menuOpen) return;
    const onKey = (e) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [menuOpen]);

  return (
    <motion.header
      className={`w-full sticky top-0 z-20 ${scrolled ? 'header-scrolled' : ''}`}
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
    >
      <div className="container">
        <div className="nav-bar">
          <a href="/" className="brand" aria-label="Z37 home">
            z37
          </a>

          <nav className="nav-links" aria-label="Primary">
            {NAV_LINKS.map((l) => (
              <a key={l.href} href={l.href} className="nav-link">
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-md">
            <a
              href="/discover"
              className="btn btn-primary btn-sm hidden-mobile"
              style={{ display: 'inline-flex' }}
            >
              Start a project
            </a>

            <button
              type="button"
              aria-label={menuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((v) => !v)}
              className="header-burger"
              style={{
                display: 'inline-flex',
                background: 'transparent',
                border: '1px solid var(--color-borders)',
                borderRadius: 'var(--radius-md)',
                padding: '0.5rem',
                cursor: 'pointer',
              }}
            >
              <span
                aria-hidden="true"
                style={{
                  display: 'block',
                  width: '20px',
                  height: '14px',
                  position: 'relative',
                }}
              >
                <span
                  style={{
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    top: menuOpen ? '6px' : 0,
                    height: '2px',
                    background: 'var(--color-text-primary)',
                    borderRadius: '2px',
                    transform: menuOpen ? 'rotate(45deg)' : 'none',
                    transition: 'transform 200ms ease, top 200ms ease',
                  }}
                />
                <span
                  style={{
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    top: '6px',
                    height: '2px',
                    background: 'var(--color-text-primary)',
                    borderRadius: '2px',
                    opacity: menuOpen ? 0 : 1,
                    transition: 'opacity 150ms ease',
                  }}
                />
                <span
                  style={{
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    top: menuOpen ? '6px' : '12px',
                    height: '2px',
                    background: 'var(--color-text-primary)',
                    borderRadius: '2px',
                    transform: menuOpen ? 'rotate(-45deg)' : 'none',
                    transition: 'transform 200ms ease, top 200ms ease',
                  }}
                />
              </span>
            </button>
          </div>
        </div>
      </div>

      <style>{`
        .header-burger { }
        @media (min-width: 768px) {
          .header-burger { display: none !important; }
        }
        @media (max-width: 767px) {
          .hidden-mobile { display: none !important; }
        }
      `}</style>

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            key="mobile-menu"
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.18, ease: [0.16, 1, 0.3, 1] }}
            style={{
              borderTop: '1px solid var(--color-borders)',
              borderBottom: '1px solid var(--color-borders)',
              background: 'rgba(255, 255, 255, 0.96)',
              backdropFilter: 'blur(12px)',
              WebkitBackdropFilter: 'blur(12px)',
            }}
          >
            <div className="container" style={{ paddingTop: 'var(--spacing-lg)', paddingBottom: 'var(--spacing-lg)' }}>
              <nav className="flex flex-col gap-md" aria-label="Mobile">
                {NAV_LINKS.map((l) => (
                  <a
                    key={l.href}
                    href={l.href}
                    onClick={() => setMenuOpen(false)}
                    style={{
                      color: 'var(--color-text-primary)',
                      fontSize: 'var(--text-lg)',
                      fontWeight: 'var(--font-medium)',
                      padding: '0.5rem 0',
                    }}
                  >
                    {l.label}
                  </a>
                ))}
                <a
                  href="/discover"
                  onClick={() => setMenuOpen(false)}
                  className="btn btn-primary"
                  style={{ alignSelf: 'flex-start', marginTop: 'var(--spacing-sm)' }}
                >
                  Start a project
                </a>
              </nav>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Header;
